<!--能耗计算对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? '修改-能耗计算' : '创建-能耗计算'" :has-form="true" class="time-event-dialog-modal" top="15%" width="30%"
      @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="数据选取" name="second">
          <div class="border-main">
            <gs-form :model="form" label-width="90px" label-position="left" gap="small">
              <gs-form-item label="时间间隔" prop="target" class="form-item-radio">
                <gs-select v-model="form.logInterval_value">
                  <gs-option v-for="item in timeArray" :key="item.value" :label="item.label" :value="item.value">
                  </gs-option>
                </gs-select>
              </gs-form-item>
              <fieldset>
                <legend>监控点位</legend>
                <gs-form-item label="对象" prop="fromObject" label-width="50px">
                  <gs-input v-model="showFromObject" style="width:84%" />
                  <gs-button @click="addObject('fromObject')">...</gs-button>
                </gs-form-item>
              </fieldset>
              <fieldset>
                <legend>接收点位</legend>
                <gs-form-item label="对象" prop="toObject" label-width="50px">
                  <gs-input v-model="showToObject" style="width:84%" />
                  <gs-button @click="addObject('toObject')">...</gs-button>
                </gs-form-item>
              </fieldset>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--   <gs-button type="primary" size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>

    <gs-modal v-model="visibleAdds" :title="'添加'" class="alarmReceiver-select" @close="closeAdd"
      @confirm="handleConfirmAdds">
      <div class="treeList">
        <gs-tree @node-click="treeClick" v-if="visibleAdds" ref="tree" :data="dataList" :props="props"
          :disable-node="true" :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      nodeId: "",
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      showFromObject: "",
      showToObject: '',
      loading: false,
      activeName: 'first',
      name: '',
      description: '',
      form: {
        logInterval_value: '',
        fromObject: {},
        toObject: {}
      },
      isEdit: false,
      visibleAdds: false,
      dataList: [],
      timeArray: [
        {
          value: '1000',
          label: '一小时'
        },
        {
          value: '1',
          label: '一天'
        }, {
          value: '10',
          label: '一周'
        },
        {
          value: '100',
          label: '一个月'
        },

      ]
    }
  },
  computed: {
    ...mapState({
      visible: 'energyDialogShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        this.isEdit = true
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'first'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'EnergyCalculation') {
          // this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.nodeId = this.objectData.id
          this.showFromObject = this.objectData.attribute.fromObject
          this.showToObject = this.objectData.attribute.toObject
          this.description = this.objectData.description
          this.name = this.objectData.name
        } else {
          this.isEdit = false
          this.form = {}
          this.description = ''
          this.name = ''
          this.showFromObject = ""
          this.showToObject = ""
        }
      } else {
        this.isEdit = false
        this.form = {}
        this.description = ''
        this.name = ''
        this.showFromObject = ""
        this.showToObject = ""
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'ENERGY_DIALOG_HIDE'
    }),
    //主
    beforeClose() {
      this.close()
    },
    handleConfirm() {
      let _this = this
      if (this.name != "" && this.form.logInterval_value != "") {
        this.form.logInterval_value == "1" ? this.form.logInterval_value = "0 57 23 * * ?" : this.form.logInterval_value == "10" ? this.form.logInterval_value = "0 0 1 ? * L" : this.form.logInterval_value == "100" ? this.form.logInterval_value = "0 15 10 L * ?" : this.form.logInterval_value == "1000" ? this.form.logInterval_value = "0 0 * * * ?" : ''
        let obj = {
          name: this.name,
          type: "EnergyCalculation",
          description: this.description,
          parentId: this.nodeData.id,
          attribute: {
            cron: this.form.logInterval_value,
            pointId: this.form.fromObject.id,
            resultId: this.form.toObject.id,
            timeStamp: "",
            jobName: 5,
            jobGroupName: this.nodeData.name,
            fromObject: this.showFromObject,
            toObject: this.showToObject
          }
        }
        if (_this.isEdit) {
          obj.id = this.nodeId
          obj.attribute.pointId = this.form.pointId
          obj.attribute.resultId = this.form.resultId
          service.renamePoint(obj).then(res => {
            _this.close()
            this.$Message.success("修改成功！")
          })
        } else {
          service.newAddPoint(obj).then(res => {
            _this.close()
            this.$Message.success("创建成功！")
          })
        }
      } else {
        this.$Message.info("请填写完整信息！")
      }


      /* // 生成cron表达式
      let _this = this
      let days = []
      let cornStartArray = []
      let cornStoptArray = []
      this.checkedCities.forEach(e => {
        switch (e) {
          case '星期一':
            days[0] = '2'
            break
          case '星期二':
            days[1] = '3'
            break
          case '星期三':
            days[2] = '4'
            break
          case '星期四':
            days[3] = '5'
            break
          case '星期五':
            days[4] = '6'
            break
          case '星期六':
            days[5] = '7'
            break
          case '星期日':
            days[6] = '1'
            break
          default:
            break
        }
      })
      days = days.join(',')
      //this.loading = true
      this.timeChartList.forEach(e => {
        delete e.id
        // 开始时间分隔生成corn表达式
        let arrayStart = e.startTime.split(":")
        let flipArrStart = arrayStart.reverse()
        let numberArrStart = flipArrStart.map(Number)
        let stringJoinStart = numberArrStart.join(" ")
        let cornStart = `0 ${stringJoinStart} ? * ${days}`
        cornStartArray.push(cornStart)
        // 结束时间
        let arrayStop = e.stopTime.split(":")
        let flipArrStop = arrayStop.reverse()
        let numberArrStop = flipArrStop.map(Number)
        let stringJoinStop = numberArrStop.join(" ")
        let cornStop = `0 ${stringJoinStop} ? * ${days}`
        cornStoptArray.push(cornStop)
      })
      console.log(cornStoptArray)
      // 生成cron数组
      let cron = []
      for (let i = 0; i < cornStartArray.length; i++) {
        this.objectSeries.forEach(e => {
          let cronData = {}
          let keyCron = cornStartArray[i]
          let value = {}
          let keyid = e.id
          let startValue = e.startnum
          value[keyid] = startValue
          cronData[keyCron] = value
          cron.push(cronData)
        })
      }
      for (let i = 0; i < cornStoptArray.length; i++) {
        this.objectSeries.forEach(e => {
          let cronData = {}
          let keyCron = cornStoptArray[i]
          let value = {}
          let keyid = e.id
          let stopValue = e.stopnum
          value[keyid] = stopValue
          cronData[keyCron] = value
          cron.push(cronData)
        })
      }
      if (this.objectData.id && this.objectData.type === 'timeChart') {
        let param = {
          id: this.objectData.id,
          'name': this.name,
          'type': 'timeChart',
          value: this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': {
            'objectSeries': this.objectSeries,
            "deviceGroupId": this.objectData.parentId,
            "cron": cron,
            "jobGroupName": this.nodeData.name,
            "jobName": 1,
            timeInterval: this.num,
            logSpace_unit: this.logSpace_unit,
            events: this.timeChartList
          } // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$notify.success({
            message: '修改成功',
            offset: 24,
            showClose: false,
            duration: '1000'
          });
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      } else {
        let param = {}
        if (this.select) {
          if (this.selection.length === 0) {
            let arr = this.timeChartList[0].weekDays.split("")
            this.timeChartList[0].weekDays = arr
            param = {
              'name': this.name,
              'type': 'timeChart',
              'parentId': this.objectData.id,
              'description': this.description,
              'attribute': {
                'objectSeries': this.objectSeries,
                'timeChartList': this.timeChartList,
                "deviceGroupId": this.objectData.parentId,
                "cron": cron,
                "jobGroupName": this.nodeData.name,
                "jobName": 1,
                timeInterval: this.num,
                logSpace_unit: this.logSpace_unit,
                events: this.timeChartList,
                toValue: this.objectSeries,
              } // 其他信息这里，键值对形式
            }
          } else {
            let arr = this.timeChartList[0].weekDays.split("")
            this.timeChartList[0].weekDays = arr
            param = {
              'name': this.name,
              'type': 'timeChart',
              'parentId': this.objectData.id,
              'description': this.description,
              'attribute': {
                'objectSeries': this.objectSeries,
                'timeChartList': this.timeChartList,
                "deviceGroupId": this.objectData.parentId,
                "cron": cron,
                "jobGroupName": this.nodeData.name,
                "jobName": 1,
                timeInterval: this.num,
                logSpace_unit: this.logSpace_unit,
                events: this.selection,
                toValue: this.objectSeries
              } // 其他信息这里，键值对形式
            }
          }
        } else {
          //   let arr =  this.timeChartList[0].weekDays.split("")
          //   this.timeChartList[0].weekDays = arr
          param = {
            'name': this.name,
            'type': 'timeChart',
            'parentId': this.objectData.id,
            'description': this.description,
            'attribute': {
              'objectSeries': this.objectSeries,
              "deviceGroupId": this.objectData.parentId,
              "cron": cron,
              "jobGroupName": this.nodeData.name,
              "jobName": 1,
              timeInterval: this.num,
              logSpace_unit: this.logSpace_unit,
              events: this.timeChartList,
              toValue: this.objectSeries   // 这里是点位数值
            } // 其他信息这里，键值对形式
          }
        }
        this.select = false
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$notify.success({
            message: '添加成功',
            offset: 24,
            showClose: false,
            duration: '1000'
          });
          _this.objectSeries = []
          _this.timeChartList = []
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      }
      this.select = false */

    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    addObject(input) {
      let _this = this
      _this.dataList = []
      this.visibleAdds = true
      if (this.nodeData.type == "server" || this.nodeData.type == "project") {
        switch (input) {
          case 'fromObject':
            _this.addTitle = '监控点位'
            setTimeout(() => {
              /* _this.dataList = _this.$store.state.nodeAll */
              service.getAllTree().then(res => {
                _this.dataList = res
              })
            }, 1000)
            break
          case 'toObject':
            _this.addTitle = '接收点位'
            setTimeout(() => {
              service.getAllTree().then(res => {
                _this.dataList = res
              })
            }, 1000)
            break
          default:
            break
        }
      }
      else if (this.nodeData.type == "logicalGroup") {
        service.getTree('', this.nodeData.id).then(res => {
          res[0].children.forEach(item => {
            service.getTree('Point', item.id).then(restree => {
              item.children = restree[0].children
            })
          })
          switch (input) {
            case 'fromObject':
              _this.addTitle = '监控点位'
              setTimeout(() => {
                _this.dataList = res
              }, 3000)

              break
            case 'toObject':
              _this.addTitle = '接收点位'
              setTimeout(() => {
                _this.dataList = res
              }, 3000)
              break
            default:
              break
          }

        })
      } else {
        switch (input) {
          case 'fromObject':
            this.addTitle = '监控点位'
            service.getTree('Point', this.nodeData.id).then(res => {
              if (res[0] !== null) {
                this.dataList = res
              }
              this.dataList = res
            })
            //this.dataList = treeArr
            break
          case 'toObject':
            this.addTitle = '接收点位'
            service.getTree('Point', this.nodeData.id).then(res => {
              if (res[0] !== null) {
                this.dataList = res
              }
            })
            break
          default:
            break
        }
      }
    },
    handleConfirmAdds() {
      let _this = this
      let array = _this.$refs.tree.getCheckedNodes(true)
      let id = array[0].data.id
      if (this.addTitle === "接收点位") {
        service.getRightList(id).then(res => {
          console.log(res)
          this.tableData = res
        })
      }
      switch (this.addTitle) {
        case '监控点位':
          if (array != null && array.length > 1) {
            this.$Message.warning('最多只能选择一个')
            return
          }
          this.form.fromObject = array[0].data ? array[0].data : null
          this.showFromObject = array[0].data.name
          break
        case '接收点位':
          this.form.toObject = array[0].data ? array[0].data : null
          this.showToObject = array[0].data.name
          break
        default:
          break
      }
      this.visibleAdds = false
    },
    treeClick(data) {
      data.data.id
    },
    checkEvent(node, isSelect, halfSelect) {
      /* console.log(node)
      console.log(isSelect)
      console.log(halfSelect) */
      // value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      switch (node.type) {
        case 'value_Analog':
          this.singleChoice(node.id)
          break
        case 'value_Multistate':
          this.singleChoice(node.id)
          break
        case 'value_Binary':
          this.singleChoice(node.id)
          break
        case 'value_String':
          this.singleChoice(node.id)
          break
        case 'BinaryInput':
          this.singleChoice(node.id)
          break
        case 'BinaryOutput':
          this.singleChoice(node.id)
          break
        case 'AnalogInput':
          this.singleChoice(node.id)
          break
        case 'AnalogOutput':
          this.singleChoice(node.id)
          break
        case 'boolWrite':
          this.singleChoice(node.id)
          break

        case 'BinaryInputW':
          this.singleChoice(node.id)
          break
        case 'BinaryInputR':
          this.singleChoice(node.id)
          break
        case 'BinaryOutputW':
          this.singleChoice(node.id)
          break
        case 'BinaryOutputR':
          this.singleChoice(node.id)
          break
        case 'AnalogInputW':
          this.singleChoice(node.id)
          break
        case 'AnalogInputR':
          this.singleChoice(node.id)
          break
        case 'AnalogOutputW':
          this.singleChoice(node.id)
          break
        case 'AnalogOutputR':
          this.singleChoice(node.id)
          break
        case 'DigitalOutputW':
          this.singleChoice(node.id)
          break
        case 'DigitalOutputR':
          this.singleChoice(node.id)
          break
        case 'DigitalInputW':
          this.singleChoice(node.id)
          break
        case 'DigitalInputR':
          this.singleChoice(node.id)
          break
        case 'AnalogW':
          this.singleChoice(node.id)
          break
        case 'IntegerW':
          this.singleChoice(node.id)
          break
        case 'AnalogR':
          this.singleChoice(node.id)
          break
        case 'IntegerR':
          this.singleChoice(node.id)
          break
        case 'BinaryW':
          this.singleChoice(node.id)
          break
        case 'BinaryR':
          this.singleChoice(node.id)
          break
        default:
          this.$Message.error('此节点为目录，无法被选择')
          this.$refs.tree.setChecked(node.id, false)
          break
      }
    },
    // 单选操作
    singleChoice(id) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys()
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach(item => {
          if (item != id) {
            this.$refs.tree.setChecked(item, false)
          }
        })
      }
    },
    closeAdd() {

    },
  }
}
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.inp>>>.gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries>>>.gs-form-item {
  margin-bottom: 0px m !important;
}
</style>



// WEBPACK FOOTER //
// src/components/timeChart/energyDialog.vue